import {
  Briefcase,
  TrendingUp,
  Smartphone,
  Monitor,
  ShoppingCart,
  Layers,
} from "lucide-react";
import { Link } from "react-router-dom";
import TitleSecond from "../common/TitlesSecond";

const solutionGroups = [
  {
    name: "Tất cả",
    icon: Layers,
    note: "Tổng hợp khung giải pháp cho nhiều bài toán triển khai",
  },
  {
    name: "Website Doanh nghiệp & Thương mại điện tử",
    icon: ShoppingCart,
    note: "Tối ưu trải nghiệm, SEO và chuyển đổi bán hàng",
  },
  {
    name: "Giao diện Hệ thống quản trị",
    icon: Monitor,
    note: "Dashboard CRM, ERP tinh gọn và POS nội bộ",
  },
  {
    name: "Landing Page chiến dịch Marketing",
    icon: TrendingUp,
    note: "Tập trung lead, tracking và hiệu quả quảng cáo",
  },
  {
    name: "Ứng dụng di động",
    icon: Smartphone,
    note: "Mobile UI UX cho tác vụ doanh nghiệp và khách hàng",
  },
  {
    name: "Theo ngành nghề triển khai",
    icon: Briefcase,
    note: "Du lịch, khách sạn, bán lẻ, dịch vụ và nhiều lĩnh vực khác",
  },
];

const SectionStore = ({
  bg = "bg-[#fff8f8]",
  value = "Danh mục nền tảng & giao diện cấu trúc theo mục tiêu giải pháp",
}: {
  bg?: string;
  value?: string;
}) => {
  return (
    <section className={`${bg} mt-5 overflow-hidden py-16`}>
      <div className="container flex flex-col items-center justify-center px-4 py-8 sm:px-6 sm:py-10">
        <TitleSecond>{value}</TitleSecond>
        <p className="mt-4 max-w-3xl text-center text-[15px] leading-8 text-slate-600">
          Thay vì chỉ chọn một mẫu giao diện, doanh nghiệp có thể bắt đầu từ đúng mục tiêu cần
          triển khai: bán hàng, quản trị vận hành, chiến dịch Marketing hay ứng dụng mobile. Đây là
          lớp khung giúp TrioCore rút ngắn thời gian triển khai và mở rộng hệ thống về sau.
        </p>

        <div className="mt-12 grid w-full max-w-[1120px] gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {solutionGroups.map(({ name, icon: Icon, note }) => (
            <div
              key={name}
              className="rounded-[22px] border border-red-100 bg-white/92 p-5 text-left shadow-[0_14px_34px_rgba(127,29,29,0.05)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_42px_rgba(127,29,29,0.08)]"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-red-100 bg-red-50 text-red-600">
                <Icon size={24}  />
              </div>
              <h3 className="mt-4 text-[16px] font-semibold leading-6 text-[#2f1a1a]">{name}</h3>
              <p className="mt-2 text-[13px] leading-6 text-slate-600">{note}</p>
            </div>
          ))}
        </div>

        <div className="mt-12">
          <Link
            to="/store/website"
            className="inline-flex items-center rounded-full bg-red-600 px-6 py-3 text-sm font-semibold text-white transition hover:bg-red-700"
          >
            Xem toàn bộ thư viện giải pháp
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SectionStore;
